// eslint-disable-next-line
import React, { useEffect, useRef } from "react";

import useWindowDimensions from '../../hooks/windowSize';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { BsTelegram, BsTwitter } from 'react-icons/bs';
import { FaWallet, FaHandHoldingUsd } from 'react-icons/fa';
import { AiOutlineSwap } from 'react-icons/ai';
import { BiLineChart, BiChevronDown } from 'react-icons/bi';

const Footer = () => {
  const { height, width } = useWindowDimensions();
  return (
    <>
      <footer className="footSection padSection ">
        <div className="partners">
          <div className="container">
            <div className="par_cal" >
              <OwlCarousel className='owl-theme' loop margin={10} items={width > 1200 ? 7 : 3} nav>
                <div className='item p-2'>
                  <a href='https://bscscan.com/'>
                    <img src="./images/bsc_partner.png" alt='Slider' />
                  </a>
                </div>
                <div className='item p-2'>
                  <a href='https://coincodex.com/'>
                    <img src="./images/coin_partner.png" alt='Slider' />
                  </a>
                </div>
                <div className='item p-2'>
                  <a href='https://coincheckup.com/'>
                    <img src="./images/coincap_partner.png" alt='Slider' />
                  </a>
                </div>
                <div className='item p-2'>
                  <a href='https://coinmarketcap.com/'>
                    <img src="./images/coinmarketcap.png" alt='Slider' />
                  </a>
                </div>
                <div className='item p-2'>
                  <a href='https://www.coingecko.com/'>
                    <img src="./images/coingecko.png" alt='Slider' />
                  </a>
                </div>
                <div className='item p-2'>
                  <a href='https://www.coinlore.com/'>
                    <img src="./images/coinlore_partner.png" alt='Slider' />
                  </a>
                </div>
              </OwlCarousel>
            </div>
          </div>
        </div>
        <div className="b_footer">
          <div className="container">
            <div className="row clearfix align-items-center">
              <div className="col-sm-6 text-left">
                <a href="./"><img src="./images/logo.png" alt="" className="img-responsive f_logo" /></a>
              </div>
              <div className="col-sm-6 text-right">
                <div className="social_icon">
                  <a href="https://web.telegram.org/k/#@thegrayscurrency"><BsTelegram /></a>
                  <a href="https://mobile.twitter.com/TGCERC20"><BsTwitter /></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="copy">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 text-left">
                <p>© Copyright 2022. All Rights Reserved</p>
              </div>
              <div className="col-sm-6 text-right">
                <p><a href="#">Disclaimer</a><a href="#">Privacy</a></p>

              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;